import React from 'react';
import { useSiteLogo } from '@/hooks/useSiteLogo';
import { FooterBrand, QuickLinks, ProductLinks, ContactInfo } from '@/components/footer/FooterColumns';
import { MarketLinks, B2BPlatforms, FooterBottom } from '@/components/footer/FooterBottom';

export default function Footer() {
  const logoUrl = useSiteLogo();
  return (
    <footer className="bg-spice-deep text-cream-warm" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <FooterBrand logoUrl={logoUrl} />
          <QuickLinks />
          <ProductLinks />
          <ContactInfo />
        </div>
        <MarketLinks />
        <B2BPlatforms />
        <FooterBottom />
      </div>
    </footer>
  );
}
